import { Box } from '@mui/material'
import { useGetTreeById } from 'reducers/trees_hooks'
import { GoogleLoginButton, googleUserAtom } from 'infrastructure/googleDrive'
import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import React from 'react'
import { Export } from './Export'
import { Import } from './Import'

export function BulkAddContent({
  treeId,
  versionId,
}: {
  treeId: string
  versionId: string
}) {
  const treeData = useGetTreeById({ treeId, versionId })
  const guser = useAtomValue(googleUserAtom)

  if (!treeData.tree) return <Box>Loading...</Box>

  if (!guser.credential?.accessToken) {
    return (
      <Box>
        <GoogleLoginButton hideWhenLoggedIn={true} />
      </Box>
    )
  }

  return (
    <Box>
      <Box>Bulk Add Content</Box>
      <Export
        tree={treeData.tree}
        accessToken={guser.credential?.accessToken}
      />
      <hr />
      <Import
        tree={treeData.tree}
        accessToken={guser.credential?.accessToken}
      />
    </Box>
  )
}
